import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_legal/Header/Header.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_legal/Contents/Contents.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_legal/FilesComponent/FilesComponent.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/ui/CopyToClipboard/CopyToClipboard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
